import React, { useCallback } from 'react'

import TextButton from 'LuxKit/Button/TextButton'
import { useAppSelector } from 'hooks/reduxHooks'
import { appViewMessageHandler } from 'lib/window/webViewUtils'
import { isHeadlessModeSel } from 'selectors/configSelectors'
import FooterWithCreateUpdateInfo from 'tripPlanner/components/TripModal/Common/FooterWithCreateUpdateInfo'
import { MANAGE_BOOKING } from 'tripPlanner/types/common'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
  orderId: string
}

export default function OwnBookingFooter({ item, orderId }: Props) {
  const isHeadless = useAppSelector(isHeadlessModeSel)

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (isHeadless) {
        e.preventDefault()
        appViewMessageHandler('nativeNavigation', MANAGE_BOOKING)
      }
    },
    [isHeadless],
  )

  return (
    <FooterWithCreateUpdateInfo item={item}>
      <TextButton
        kind="primary"
        size="large"
        to={`/account/my-escapes/order/${orderId}`}
        target="_blank"
        onClick={handleClick}
      >
        Manage Booking
      </TextButton>
    </FooterWithCreateUpdateInfo>
  )
}
